import { matchPath } from 'react-router-dom';

const PATTERNS = [
  '/viewgroups/:tournamentId',
  '/matches/:tournamentId',
  '/viewbracket/:tournamentId',
  '/viewer/:tournamentId',
];

/**
 * Rutas de solo-visor (grupos, partidos, bracket): sin header/footer principal.
 * posterStudio: estudio de cartel a pantalla completa (barra propia con Volver).
 */
export function getImmersiveMatch(pathname) {
  const poster = matchPath({ path: '/tournamentactions/:tournamentId/premium-media', end: true }, pathname);
  if (poster?.params?.tournamentId) {
    return {
      isImmersive: true,
      tournamentId: poster.params.tournamentId,
      immersiveMode: 'posterStudio',
    };
  }
  for (const path of PATTERNS) {
    const m = matchPath({ path, end: true }, pathname);
    if (m?.params?.tournamentId) {
      return { isImmersive: true, tournamentId: m.params.tournamentId, immersiveMode: 'viewer' };
    }
  }
  return { isImmersive: false, tournamentId: null, immersiveMode: null };
}

/** Hub del torneo (grupos / partidos / bracket / visor); el visor en rotacion es solo una opcion de esa pagina. */
export function immersiveFallbackPath(tournamentId) {
  if (tournamentId) return `/tournamentactions/${tournamentId}`;
  return '/';
}
